import React from 'react';
import { TFunction } from 'i18next';
import { Trans } from 'react-i18next';
import { ECountry } from 'common/const';
import { getComplainPrivacyPolicyUrl } from 'common/helpers/documents.helper';
import { IComplainFormData } from 'common/types/complain.types';

export const getComplainAgreementItems = (
  t: TFunction<'translation', undefined>,
  formData: IComplainFormData,
  country: ECountry,
) => {
  return [
    {
      label: (
        <Trans
          i18nKey="payment.complain.complainTermsAndConditions"
          values={{
            privacyPolicy: t('payment.complain.privacyPolicy'),
          }}
          components={{
            1: <a href={getComplainPrivacyPolicyUrl(country)} target="_blank" rel="noopener noreferrer" />,
          }}
        />
      ),
      name: 'terms_and_conditions',
      checked: formData.terms_and_conditions,
    },
  ];
};
